<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KClgrN/tc-custom/9780062322470.jpg?1726519051569" alt="This image is the cover for the book Arts & Entertainments"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Arts & Entertainments
      </h1>
      <p class="bookDescription body article font2">
        <p>Christopher Beha delivers a cutting send-up of our cultural obsession with celebrity—a deliciously witty, and ultimately tender, novel about the absurdity of fame and the complexity of love sure to appeal to fans of Maria Semple and Jess Walter.</p><p>A sharp-edged satire with heart, <i>Arts &amp; Entertainments</i> is the story of Handsome Eddie Hartley who, at thirty-three, has forgone dreams of an acting career for the reality of life as a drama teacher at a boys’ prep school. But when Eddie and his wife, Susan, discover they cannot have children, it is one disappointment too many.</p><p>Weighted down with debt, his wife’s mounting unhappiness, and his own deepening sense of failure, Eddie is confronted with an alluring solution when an old friend-turned-web-impresario suggests Eddie sell a sex tape he made with an ex-girlfriend, now a wildly popular television star. Overcoming his initial moral qualms, Eddie figures that in an era when any publicity is good publicity, the tape won’t cause any harm—a decision that will have disastrous consequences and propel him straight into the glaring spotlight he once thought he craved.</p><p>A hilariously biting and incisive take-down of our culture’s monstrous obsession with fame, <i>Arts &amp; Entertainments</i> is also a poignant and humane portrait of a young man’s belated coming-of-age, the complications of love, and the surprising ways in which the most meaningful lives often turn out to be the ones we least expected to lead.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher Beha
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?92b3920e